const initialState = {
	isLoading: 0,
	hasError: 0
}

export default (state = initialState, action) => {
	switch (action.type){
		case 'SUGGESTED_PRODUCTS_ARE_LOADING':
			return {
				...state,
				isLoading: 1
			}
		case 'SUGGESTED_PRODUCTS_HAS_ERROR':
			return {
				...state,
				isLoading: 0,
				hasError: 1
			}
		case 'SUGGESTED_PRODUCTS_SUCCESS':
			return {
				...state,
				...action.data.data,
				isLoading: 0
			}

		default:
			return state
	}
}


// WEBPACK FOOTER //
// ./src/store/reducers/suggestedProducts.js